import {
  Typography,
  Tooltip,
  IconButton,
  Snackbar,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import useCopyText from "../hooks/useCopyText";

function CopyableTextPaper({ text }) {
  const { copyToClipboard, isCopied } = useCopyText();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    // setIsCopied(false);
  };

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          p: isSmallScreen ? 1 : 2,
          display: "flex",
          flexDirection: isSmallScreen ? "column" : "row",
          alignItems: "center",
          justifyContent: isSmallScreen ? "center" : "space-between",
          maxWidth: "100%",
          m: isSmallScreen ? 1 : 2,
          wordBreak: "break-word",
          cursor: "pointer", // Indicate that it's clickable
        }}
        onClick={() => copyToClipboard(text)} // Allow clicking anywhere to copy
      >
        <Typography
          variant={isSmallScreen ? "body2" : "body1"}
          sx={{
            mr: isSmallScreen ? 0 : 2,
            mb: isSmallScreen ? 1 : 0,
            textAlign: isSmallScreen ? "center" : "left",
            width: "100%",
          }}
        >
          {text}
          {/* {isSmallScreen && <span style={{ fontSize: '0.8em', color: theme.palette.text.secondary }}> (Tap to copy)</span>} */}
        </Typography>
        <Tooltip title={isCopied ? "Copied!" : "Copy to clipboard"}>
          <IconButton
            onClick={() => copyToClipboard(text)}
            color={isCopied ? "success" : "default"}
            size={isSmallScreen ? "small" : "medium"}
          >
            {isCopied ? <CheckCircleOutlineIcon /> : <ContentCopyIcon />}
          </IconButton>
        </Tooltip>
      </Paper>
      <Snackbar
        open={isCopied}
        autoHideDuration={2000}
        onClose={handleClose}
        message="Copied to clipboard!"
      />
    </>
  );
}

export default CopyableTextPaper;
